import { Divider, styled } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ScheduleIcon from "@mui/icons-material/Schedule";

export const CalendarIcon = styled(CalendarTodayIcon)({
  width: "16px",
  height: "16px",
  color: "#646D7B"
});

export const ClockIcon = styled(ScheduleIcon)({
  width: "16px",
  height: "16px",
  color: "#646D7B"
});

export const StyledDivider = styled(Divider)({
  margin: "12px 0px",
  background: "#EFF4FF"
});
